module.exports = __webpack_public_path__ + "static/img/FuXiang_yingtaoPic.35ad0ab8.png";